<script lang="ts">
    import catsBackground from 'src/components/main/home/components/home-intro/cats.jpg'
    import catsTabletBackground from 'src/components/main/home/components/home-intro/cats-tablet.jpg'
    import catsMobileBackground from 'src/components/main/home/components/home-intro/cats-mobile.jpg'

    import dragonsBackground from 'src/components/main/home/components/home-intro/dragons.jpg'
    import dragonsTabletBackground from 'src/components/main/home/components/home-intro/dragons-tablet.jpg'
    import dragonsMobileBackground from 'src/components/main/home/components/home-intro/dragons-mobile.jpg'

    import foxesBackground from 'src/components/main/home/components/home-intro/foxes.jpg'
    import foxesTabletBackground from 'src/components/main/home/components/home-intro/foxes-tablet.jpg'
    import foxesMobileBackground from 'src/components/main/home/components/home-intro/foxes-mobile.jpg'

    import dogesBackground from 'src/components/main/home/components/home-intro/doges.jpg'
    import dogesTabletBackground from 'src/components/main/home/components/home-intro/doges-tablet.jpg'
    import dogesMobileBackground from 'src/components/main/home/components/home-intro/doges-mobile.jpg'

    import elonBackground from 'src/components/main/home/components/home-intro/elon.jpg'
    import elonTabletBackground from 'src/components/main/home/components/home-intro/elon-tablet.jpg'
    import elonMobileBackground from 'src/components/main/home/components/home-intro/elon-mobile.jpg'

    import elementalWarBackground from 'src/components/main/home/components/home-intro/elemental-war.jpg'
    import elementalWarTabletBackground from 'src/components/main/home/components/home-intro/elemental-war-tablet.jpg'
    import elementalWarMobileBackground from 'src/components/main/home/components/home-intro/elemental-war-mobile.jpg'

    import cryptoPepeBackground from 'src/components/main/home/components/home-intro/crypto-pepe.jpg'
    import cryptoPepeTabletBackground from 'src/components/main/home/components/home-intro/crypto-pepe-tablet.jpg'
    import cryptoPepeMobileBackground from 'src/components/main/home/components/home-intro/crypto-pepe-mobile.jpg'

    import googlePlay from 'src/components/main/#assets/google-play.svg'
    import arrow from 'src/components/main/home/components/home-intro/arrow-right.svg'

    import { Swiper, SwiperSlide } from 'swiper/svelte'
    import { Pagination, Autoplay, Navigation } from 'swiper'
    import 'swiper/css'
    import 'swiper/css/pagination'
    import 'swiper/css/autoplay'

    let swiper
</script>

<section class="main-intro home-slider">
    <div class="centered-mode">
        <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={40}
            slidesPerView={1}
            centeredSlides={true}
            loop={true}
            autoplay={{ delay: 6000 }}
            pagination={{ clickable: true }}
            effect="fade"
            on:swiper={e => swiper = e.detail[0]}
        >
            <!--
            <SwiperSlide>
                <div class="slide slide-1" style="
                    --catsBackground:url({catsBackground});
                    --catsTabletBackground:url({catsTabletBackground});
                    --catsMobileBackground:url({catsMobileBackground});
                ">
                    <div class="main-intro-content">
                        <div class="container">
                            <h1 class="intro-title">Only crypto cats can be better than cats</h1>
                            <div class="intro-description">Merge cute pets, collect DRAG Token and win prizes</div>
                            <a href="https://play.google.com/store/apps/details?id=com.soul.merge.cat.cute.simulator.adventure" target="_blank" class="google-play">
                                <img src="{googlePlay}" alt="google play">
                            </a>
                        </div>
                    </div>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div class="slide slide-2" style="
                    --dragonsBackground:url({dragonsBackground});
                    --dragonsTabletBackground:url({dragonsTabletBackground});
                    --dragonsMobileBackground:url({dragonsMobileBackground});
                ">
                    <div class="main-intro-content">
                        <div class="container">
                            <div class="intro-title">Meet mysterious dragons, complete daily quests and get DRAG rewards</div>
                            <a href="https://play.google.com/store/apps/details?id=com.dragons.tokens.crypto" target="_blank" class="google-play">
                                <img src="{googlePlay}" alt="google play">
                            </a>
                        </div>
                    </div>
                </div>
            </SwiperSlide>
            -->
            <SwiperSlide>
                <div class="slide slide-3" style="
                    --foxesBackground:url({foxesBackground});
                    --foxesTabletBackground:url({foxesTabletBackground});
                    --foxesMobileBackground:url({foxesMobileBackground});
                ">
                    <div class="main-intro-content">
                        <div class="container">
                            <div class="intro-title">Get a break with the cute and funny Fox Collector</div>
                            <!--<div class="intro-description">Your achievements will be rewarded</div>-->
                            <a href="https://play.google.com/store/apps/details?id=com.realis.fox.nft.token" target="_blank" class="google-play">
                                <img src="{googlePlay}" alt="google play">
                            </a>
                        </div>
                    </div>
                </div>
            </SwiperSlide>
            <!--
            <SwiperSlide>
                <div class="slide slide-4" style="
                    --dogesBackground:url({dogesBackground});
                    --dogesTabletBackground:url({dogesTabletBackground});
                    --dogesMobileBackground:url({dogesMobileBackground});
                ">
                    <div class="main-intro-content">
                        <div class="container">
                            <div class="intro-title">The most expected game of the whole crypto community</div>
                            <div class="intro-description">You will recognize your favorite memes in our characters.</div>
                            <a href="https://play.google.com/store/apps/details?id=elon.musk.doge.meme.blockchain.coin.twit" target="_blank" class="google-play">
                                <img src="{googlePlay}" alt="google play">
                            </a>
                        </div>
                    </div>
                </div>
            </SwiperSlide>
            -->
            <SwiperSlide>
                <div class="slide slide-5" style="
                    --elonBackground:url({elonBackground});
                    --elonTabletBackground:url({elonTabletBackground});
                    --elonMobileBackground:url({elonMobileBackground});
                ">
                    <div class="main-intro-content">
                        <div class="container">
                            <div class="intro-title">The world's first mobile game with a Meme Lord as the main character</div>
                            <a href="https://play.google.com/store/apps/details?id=com.realis.elon.nft.token" target="_blank" class="google-play">
                                <img src="{googlePlay}" alt="google play">
                            </a>
                        </div>
                    </div>
                </div>
            </SwiperSlide>
            <!--
            <SwiperSlide>
                <div class="slide slide-7" style="
                    --cryptoPepeBackground:url({cryptoPepeBackground});
                    --cryptoPepeTabletBackground:url({cryptoPepeTabletBackground});
                    --cryptoPepeMobileBackground:url({cryptoPepeMobileBackground});
                ">
                    <div class="main-intro-content">
                        <div class="container">
                            <h1 class="intro-title">Crypto Frepe: The first Game Rewarding Players with $PEPE Coin!</h1>
                            <a href="https://play.google.com/store/apps/details?id=com.frog.meme.token" target="_blank" class="google-play">
                                <img src="{googlePlay}" alt="google play">
                            </a>
                        </div>
                    </div>
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div class="slide slide-6" style="
                    --elementalWarBackground:url({elementalWarBackground});
                    --elementalWarTabletBackground:url({elementalWarTabletBackground});
                    --elementalWarMobileBackground:url({elementalWarMobileBackground});
                ">
                    <div class="main-intro-content">
                        <div class="container">
                            <h1 class="intro-title">Monetize the value of your units and build a collection from rare to supreme</h1>
                            <a href="https://play.google.com/store/apps/details?id=elemental.battler.nft.card.meowgon" target="_blank" class="google-play">
                                <img src="{googlePlay}" alt="google play">
                            </a>
                        </div>
                    </div>
                </div>
            </SwiperSlide>
            -->
        </Swiper>
        <button type=button on:click={() => swiper.slidePrev()} class="arrow-btn prev-btn"><img src="{arrow}" alt="prev"></button>
        <button type=button on:click={() => swiper.slideNext()} class="arrow-btn next-btn"><img src="{arrow}" alt="next"></button>
    </div>
</section>

<style>
    .home-slider {
        position: relative;
        overflow: hidden;
    }

    .centered-mode {
        width: calc(100vw - 300px);
        max-width: 1560px;
        margin: 0 auto;
    }

    :global(.centered-mode > .swiper) {
        overflow: visible;
    }

    .slide {
        position: relative;
        padding: 270px 0 0;
        height: 800px;
        border-radius: 0 0 8px 8px;
        opacity: .5;
        transition: .25s;
    }

    .slide-1 {
        background: var(--catsBackground) no-repeat center;
        background-size: cover;
    }

    .slide-2 {
        background: var(--dragonsBackground) no-repeat center;
        background-size: cover;
    }

    .slide-3 {
        background: var(--foxesBackground) no-repeat center;
        background-size: cover;
    }

    .slide-4 {
        background: var(--dogesBackground) no-repeat center;
        background-size: cover;
    }

    .slide-5 {
        background: var(--elonBackground) no-repeat center;
        background-size: cover;
    }

    .slide-6 {
        background: var(--elementalWarBackground) no-repeat center;
        background-size: cover;
    }

    .slide-7 {
        background: var(--cryptoPepeBackground) no-repeat center;
        background-size: cover;
    }

    .main-intro-content {
        position: relative;
        z-index: 2;
        display: none;
    }

    :global(.swiper-slide-active .main-intro-content) {
        display: block !important;
    }

    :global(.swiper-slide-active .slide) {
        opacity: 1 !important;
    }

    .main-intro-content .container {
        position: relative;
    }

    .intro-title {
        font-family: 'Anton', sans-serif;
        font-size: 60px;
        max-width: 740px;
        font-weight: 400;
        color: white;
        line-height: 110%;
        text-transform: uppercase;
    }

    .intro-description {
        font-size: 24px;
        line-height: normal;
        color: #A3A4B4;
        margin: 30px 0 0;
    }

    .game-link img {
        max-width: 100%;
    }

    .game-reviews span {
        color: #515159;
        padding-left: 2px;
    }

    .slide :global(svg.star-icon) {
        font-size: 14px;
        color: #F3BD38;
        vertical-align: top !important;
        margin: 5px 0 0 0;
    }

    .slide :global(svg.star-icon:first-child) {
        margin-left: 5px;
    }

    .google-play {
        margin-top: 100px;
        margin-bottom: 94px;
        display: table;
        position: relative;
        transition: .25s;
    }

    .google-play:hover {
        transform: translateY(-5px);
    }

    .arrow-btn {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        background: #26343c;
        border: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 50%;
        z-index: 2;
        transition: .25s;
        cursor: pointer;
    }

    .arrow-btn img {
        width: 10px;
    }

    .arrow-btn:hover {
        background: #314048;
    }

    .prev-btn {
        left: 110px;
        padding-right: 8px;
    }

    .prev-btn img {
        transform: rotate(180deg);
    }

    .next-btn {
        right: 110px;
        padding-left: 8px;
    }

    @media (max-width: 1700px) {
        .slide {
            padding: 250px 0 0 40px;
        }
    }

    @media (max-width: 1400px) {
        .intro-title {
            font-size: 50px;
            max-width: 620px;
            margin: 0 0 35px;
        }

        .intro-description {
            font-size: 20px;
            max-width: 620px;
        }

        .slide {
            padding: 250px 0 0 40px;
            height: 700px;
        }

        .google-play {
            margin-bottom: 40px;
        }

        .google-play img {
            width: 240px;
        }
    }

    @media (max-width: 1200px) {
        .intro-title{
            font-size: 40px;
            max-width: 500px;
        }

        .intro-description {
            font-size: 18px;
            max-width: 500px;
        }

        .centered-mode {
            width: calc(100vw - 200px);
        }

        .google-play {
            margin-bottom: 45px;
            margin-top: 50px;
        }

        .google-play img {
            width: 210px;
        }

        .slide {
            height: 600px;
        }

        .arrow-btn {
            width: 54px;
            height: 54px;
            top: 55%;
        }

        .prev-btn {
            left: 70px;
        }

        .next-btn {
            right: 70px;
        }
    }

    @media (max-width: 992px) {
        .intro-title {
            font-size: 46px;
            line-height: normal;
        }

        .centered-mode {
            width: calc(100vw - 140px);
        }

        .arrow-btn {
            display: none;
        }

        .main-intro {
            padding: 0;
        }

        .slide {
            min-height: 520px;
            padding: 290px 0 0 0;
        }

        .intro-title {
            font-size: 34px;
            line-height: 1.3;
            text-align: center;
            max-width: 450px;
            margin: 0 auto;
        }

        .intro-description {
            font-size: 16px;
            max-width: 450px;
            margin: 20px auto 0;
            text-align: center;
            color: #b9b9b9;
        }

        .slide-1 {
            background: var(--catsTabletBackground) no-repeat center;
            background-size: cover;
        }

        .slide-2 {
            background: var(--dragonsTabletBackground) no-repeat center;
            background-size: cover;
        }

        .slide-3 {
            background: var(--foxesTabletBackground) no-repeat center;
            background-size: cover;
        }

        .slide-4 {
            background: var(--dogesTabletBackground) no-repeat center;
            background-size: cover;
        }

        .slide-5 {
            background: var(--elonTabletBackground) no-repeat center;
            background-size: cover;
        }

        .slide-6 {
            background: var(--elementalWarTabletBackground) no-repeat center;
            background-size: cover;
        }

        .slide-7 {
            background: var(--cryptoPepeTabletBackground) no-repeat center;
            background-size: cover;
        }

        .google-play {
            position: absolute;
            left: 50%;
            transform: translate(-50%, -50%);
            bottom: 50px;
            margin: 0;
        }

        .google-play:hover {
            transform: translate(-50%, -50%);
        }

        .main-intro-content,
        .main-intro-content .container {
            height: 100%;
        }
    }

    @media (max-width: 767px) {
        .intro-title {
            font-size: 30px;
            max-width: 100%;
            margin: 0;
            padding: 0 15px;
            position: absolute;
            bottom: 160px;
            left: 0;
        }

        .intro-description {
            display: none;
        }

        .main-intro {
            margin-top: 62px;
            max-height: 600px;
        }

        .centered-mode {
            width: 100%;
        }

        .slide {
            padding: 0;
            margin-top: 0;
            height: calc(100vh - 300px);
            min-height: 440px;
            max-height: 600px;
            border-radius: 0;
        }

        .main-intro :global(.btn) {
            min-width: 180px;
        }

        .container {
            height: 100%;
        }

        .main-intro-content {
            height: 100%;
        }

        .slide-1 {
            background: var(--catsMobileBackground) no-repeat center;
            background-size: cover;
        }

        .slide-2 {
            background: var(--dragonsMobileBackground) no-repeat center;
            background-size: cover;
        }

        .slide-3 {
            background: var(--foxesMobileBackground) no-repeat center;
            background-size: cover;
        }

        .slide-4 {
            background: var(--dogesMobileBackground) no-repeat center;
            background-size: cover;
        }

        .slide-5 {
            background: var(--elonMobileBackground) no-repeat center;
            background-size: cover;
        }

        .slide-6 {
            background: var(--elementalWarMobileBackground) no-repeat center;
            background-size: cover;
        }

        .slide-7 {
            background: var(--cryptoPepeMobileBackground) no-repeat center;
            background-size: cover;
        }
    }
</style>
